import React, { useEffect } from 'react';
import { FormattedMessage } from 'react-intl';

// Hooks
import { useAppSelector } from '../../../hooks';

// Actions

// Components
import PlanSummaryAccordion from './PlanSummaryAccordion';
import PlanSummaryActions from './PlanSummaryActions';
import { ConditionalRendering } from '../../../components/common/conditional-rendering';
import withModalWrapper from '../../common/WithModalWrapper';

// hooks
import usePlanSummary from './hooks/usePlanSummary';

// Constants & Configs
import { planSummaryModalConfig } from './modals/planSummaryModalConfig';
import { modalConfig } from '../../../modules/custom-grouping/modals/modalConfig';
import { PLAN_TYPE } from '../../../modules/custom-grouping/modals/modalTypes';

const PlanSummaryContainer = () => {
    const { fetchPlanSummaryData } = usePlanSummary();

    const { planSummaryData, isDataLoading, isDataError } = useAppSelector(
        ({ individualPortal }) => individualPortal.planSummary,
    );

    useEffect(() => {
        fetchPlanSummaryData();
    }, []);

    if (isDataLoading || isDataError) return null;

    const { activeHealthPlanDetails = [], activeDentalPlanDetails = [], allowDisenrollCTA } = planSummaryData;
    const hasActivePlans = activeHealthPlanDetails.length > 0 || activeDentalPlanDetails.length > 0;

    return (
        <div id="plan-summary">
            <div className="title-container">
                <h4 data-testid="title" className="title">
                    <ConditionalRendering isTrue={hasActivePlans}>
                        <FormattedMessage id="plansummary.myplandetails" />
                    </ConditionalRendering>
                    <ConditionalRendering isTrue={!hasActivePlans}>
                        <FormattedMessage id="plansummary.noactiveenrollments" />
                    </ConditionalRendering>
                </h4>
            </div>

            <ConditionalRendering isTrue={hasActivePlans}>
                <PlanSummaryAccordion planList={activeHealthPlanDetails} planType={PLAN_TYPE.HEALTH} allowDisenrollCTA={allowDisenrollCTA} />
                <PlanSummaryAccordion planList={activeDentalPlanDetails} planType={PLAN_TYPE.DENTAL} allowDisenrollCTA={allowDisenrollCTA} />
            </ConditionalRendering>

            <PlanSummaryActions healthPlans={activeHealthPlanDetails} dentalPlans={activeDentalPlanDetails} />
        </div>
    );
};

export default withModalWrapper(PlanSummaryContainer, { ...modalConfig, ...planSummaryModalConfig });
